export enum RoleEnum {
  ADMIN = 'ADMIN',
  PCR = 'PCR',
  STAFF = 'STAFF',
  Ol = 'Ol',
  CLIENT = 'CLIENT',
  ACCOUNTANT = 'ACCOUNTANT',
  SYSTEM_ADMIN = 'SYSTEM_ADMIN'
}

export const roleEnumMapping: Record<RoleEnum, string> = {
  [RoleEnum.ADMIN]: 'Admin',
  [RoleEnum.PCR]: 'PCR',
  [RoleEnum.STAFF]: 'Staff',
  [RoleEnum.Ol]: 'Ol',
  [RoleEnum.CLIENT]: 'Client',
  [RoleEnum.ACCOUNTANT]: 'Accountant',
  [RoleEnum.SYSTEM_ADMIN]: 'System Admin'
}
